import getLocalString from "constants/Localization";
import { useGetReportAdditionalCostMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportAdditionalCost = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportAdditionalCostMutation();
  const [getReportAdditionalCost, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportAdditionalCost",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportAdditionalCost, { ...context, data }] as const;
};

export default useGetReportAdditionalCost;
